import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/pages/VerifyEmailPage.css';

export default function AccountSetupRecovery() {
  const { accountLoading, accountError, fetchUserAttributes, logout } = useAuth();
  return <main className="verify-page"><section className="verify-card" aria-labelledby="account-setup-heading">
    <h1 id="account-setup-heading">Finish setting up your account</h1>
    {accountLoading ? <p role="status">Loading your ViewFinders account…</p> : <>
      <p role="alert">{accountError?.message || 'We couldn’t load your ViewFinders account. Please try again.'}</p>
      <div className="verify-actions">
        <button className="btn btn--primary btn--lg" onClick={() => fetchUserAttributes().catch(() => {})}>Retry account setup</button>
        <button className="btn btn--secondary btn--lg" onClick={logout}>Log out</button>
      </div>
    </>}
    <p><Link to="/contact">Contact ViewFinders</Link></p>
  </section></main>;
}
